import axios, { AxiosInstance } from 'axios';
import { IPublicClientApplication } from '@azure/msal-browser';

import { acquireAuthToken } from 'src/compass/site/util';
import { isPublicRoute } from 'src/compass/shared/hooks/useCasAuthenticated';

const baseURL = process.env.REACT_APP_API_URL as string;

export const axiosAuthInstance = (
  msalInstance: IPublicClientApplication,
  account: any,
  webUser: any
): AxiosInstance => {
  // Repo-wide convention: array params serialize as repeated keys
  // (`tagIds=1&tagIds=2`) rather than axios's default `tagIds[]=1`, so ASP.NET Core
  // binds them to List<T> without a [FromQuery(Name = "x[]")] accommodation.
  // Only affects arrays; nested objects (e.g. date-range {start,end}) are unchanged.
  const instance = axios.create({ baseURL, paramsSerializer: { indexes: null } });

  instance.interceptors.request.use(async (config) => {
    if (isPublicRoute())
      config.headers.Authorization = `uid ${webUser}`;
    else {  
      const accessToken: any = await acquireAuthToken(msalInstance, account);
      config.headers.Authorization = `Bearer ${accessToken ?? ''}`;
    }
    return config;
  });

  return instance;
};
